import {
    lazyGetDiagnosticsLogState,
    lazyRegisterDiagnostics,
    DiagnosticsLogger,
} from 'owa-diagnostics';
import { renderPanel } from '../components/FormsDiagnosticsPanel';

let initialized = false;

const diagnosticsLogger: DiagnosticsLogger<string> = {
    name: 'CalendarForms',
    datapoints: [],
    type: 'Custom',
};

/**
 * Function which ensures that the logger is initialized in the diagnostics panel
 */
export default function ensureLoggerInitialized() {
    if (!initialized) {
        initialized = true;

        lazyGetDiagnosticsLogState.import().then(getDiagnosticsLogState => {
            lazyRegisterDiagnostics.importAndExecute(
                diagnosticsLogger,
                getDiagnosticsLogState(),
                renderPanel
            );
        });
    }
}
